import { ProviderGroupControllerApi, TwilioCallerId } from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

/**
 * @author Atish Bagate
 * **/

interface Params {
  providerGroupId: string;
  twilioCallerId: TwilioCallerId;
  xTENANTID?: string;
}

export const useCreateTwilioNumber = () =>
  useMutationWithLoading(async (params: Params) =>
    new ProviderGroupControllerApi(getConfigObject()).setProviderGroupCallerId(
      params?.providerGroupId,
      params?.twilioCallerId,
      params?.xTENANTID
    )
  );
